import React, { useRef } from 'react';
import RoadCard from './RoadCard';

import useScrollObserver from '../../../../hooks/useScrollObserver';

const Road = () => {
  const observerRef = useRef();
  const handleScrollIntoView = () => {
    observerRef.current.classList.add('animate');
  };
  useScrollObserver(observerRef, handleScrollIntoView);
  return (
    <div className="bg-[#EEEAF9] overflow-hidden">
      <div className="container">
        <div className="flex md:flex-row flex-col items-center h-full justify-center pb-[48px] pt-[48px] md:pt-[137px] md:gap-[124px] gap-[48px]">
          <div className="flex flex-col max-w-[350px] gap-[24px]">
            <h2 className={'font-[600] text-[32px] md:text-[34px] leading-[39px] md:leading-[42px] text-black md:text-center'}>
              The Road to Top Ranking:
              <br /> Our Process
            </h2>
            <p className="font-[400] text-[18px] leading-[22px] text-black">
              Each Step Carefully Designed and Executed to Ensure Maximum Effectiveness in Achieving Top SEO Rankings
            </p>
          </div>
          <div ref={observerRef} className="relative w-full">
            <div className="w-full flex flex-col relative z-[3]">
              <RoadCard
                cardClass="fade-in-from-right animation-delay-200 linear opacity-0"
                dashed={true}
                firstSectionClass="text-[#D9A8E5] border-[#D9A8E5]"
                firstSectionText="message"
                headerText="Initial Free Consultation"
                text="We begin by understanding your unique business goals and reviewing your current online presence. This allows us to create a professional SEO strategy specifically designed to boost your visibility and engagement, ensuring a complete digital marketing strategy and improved search results."
              />
              <RoadCard
                cardClass="fade-in-from-right animation-delay-400 linear opacity-0"
                dashed={true}
                firstSectionClass="text-[#0052B4] border-[#0052B4]"
                firstSectionText="rocket"
                headerText="Project Launch"
                text="Our SEO journey begins once we sign the contract and receive a 50% prepayment, securing our partnership and guaranteeing results. We begin with in-depth research specific to your industry and target audience. This ensures that our strategies align with your business objectives, current market trends, and the offerings of a good SEO company."
              />
              <RoadCard
                cardClass="fade-in-from-right animation-delay-600 linear opacity-0"
                dashed={true}
                firstSectionClass="text-[#D9A8E5] border-[#D9A8E5]"
                firstSectionText="magnifier"
                headerText=" SEO Development & Execution"
                text="We develop and implement a comprehensive professional SEO services plan tailored to your target audience and business objectives, ensuring progress of your SEO. We handle all aspects of SEO, both on your website and off, to improve its structure and content for greater visibility, ensuring the right SEO strategies are implemented."
              />
              <RoadCard
                cardClass="fade-in-from-right animation-delay-800 linear opacity-0"
                dashed={true}
                firstSectionClass="text-[#0052B4] border-[#0052B4]"
                firstSectionText="eye"
                headerText="Monitoring and Reporting"
                text="As a professional SEO Agency, we regularly track the success of our Search Engine Optimization Services. We provide you with easy-to-understand reports. We developed advanced reporting systems and provide comprehensive data using tools like Google Analytics, Google Search Console, Semrush, Moz & more. You'll receive insights into your campaign's performance and the specific results of our initiatives."
              />
              <RoadCard
                cardClass="fade-in-from-right animation-delay-1000 linear opacity-0"
                dashed={false}
                firstSectionClass="text-[#D9A8E5] border-[#D9A8E5]"
                firstSectionText="gear"
                headerText="Ongoing Optimization"
                text="Professional SEO services & website optimization services are an ongoing effort, and we are committed to adapting our strategies as market conditions evolve. We'll work closely with you to refine our approach, ensuring sustained improvement and success in your search rankings."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Road;
